import React from 'react';
import { useNavigate } from 'react-router-dom';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Quote from '../../assets/svgs/quote.svg';
import TestimonailBg from '../../assets/svgs/testimonial-bg.svg';

import testimonials from '../../data/testimonials';
import Button from '../inputs/Button';

function Testimonial() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1150 },
      items: 2.1
    },
    midi_desktop: {
      breakpoint: { max: 1150, min: 980 },
      items: 2
    },
    mini_desktop: {
      breakpoint: { max: 980, min: 890 },
      items: 1.8
    },
    tablet: {
      breakpoint: { max: 890, min: 770 },
      items: 1.6
    },
    midi_tablet: {
      breakpoint: { max: 770, min: 690 },
      items: 1.4
    },
    mini_tablet: {
      breakpoint: { max: 690, min: 540 },
      items: 1.3
    },
    mobile: {
      breakpoint: { max: 540, min: 485 },
      items: 1.2
    },
    midi_mobile: {
      breakpoint: { max: 485, min: 400 },
      items: 1.1
    },
    mini_mobile: {
      breakpoint: { max: 400, min: 0 },
      items: 1
    }
  };

  const navigate = useNavigate();

  return (
    <section
      style={{ background: `url(${TestimonailBg}) bottom no-repeat` }}
      className="relative w-full pb-20 mb-32 md:!bg-contain"
    >
      <div className="content">

        {/* Header row */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-6">
          <div className="max-w-lg">
            <p className="text-xs text-primary uppercase tracking-widest font-semibold mb-2">What they say</p>
            <h1 className="section-header mb-3">Testimonials</h1>
            <p className="big-p">
              Here&apos;s what Knights have to say about our Corporate University
            </p>
          </div>
          <div className="flex-shrink-0">
            <Button
              paddingX="px-10"
              paddingY="py-3"
              onClick={() => navigate('/#contact-us')}
            >
              Join Us Today
            </Button>
          </div>
        </div>

        <Carousel
          arrows
          infinite
          autoPlay
          autoPlaySpeed={3000}
          responsive={responsive}
          centerMode={false}
          customTransition="transform 0.55s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
          transitionDuration={550}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
        >
          {testimonials.map((item) => (
            <div key={item.name} className="mx-2">
              <div className="group relative bg-white rounded-2xl px-8 py-8 flex flex-col h-[360px] shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 overflow-hidden">

                {/* Purple accent top bar */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-primary rounded-t-2xl" />

                {/* Large faint quote mark in background */}
                <span className="absolute top-4 right-5 text-[80px] leading-none text-primary/10 font-serif select-none pointer-events-none">&ldquo;</span>

                {/* Quote icon */}
                <img src={Quote} alt="Quote" className="w-9 h-auto mb-4 opacity-80" />

                {/* Testimony — clamped to 4 lines so all cards stay equal */}
                <div className="flex-grow overflow-hidden mb-6">
                  <p className="text-base font-medium text-textColor leading-7 line-clamp-4">
                    &ldquo;
                    {item.testimony}
                    &rdquo;
                  </p>
                </div>

                {/* Divider */}
                <div className="w-10 h-[2px] bg-primary/40 rounded-full mb-4 flex-shrink-0" />

                {/* Author */}
                <div className="flex items-center space-x-4 flex-shrink-0">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0 ring-2 ring-primary/30"
                  />
                  <div>
                    <h3 className="font-bold font-title text-base leading-tight text-textColor">{item.name}</h3>
                    <p className="text-xs text-primary font-semibold leading-snug mt-0.5 uppercase tracking-wide">{item.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>

      </div>
    </section>
  );
}

export default Testimonial;
